// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"f4dbb379","206":"b093894c","272":"4602490e","390":"0d2d175e","667":"2140c08d","668":"95de58e6"}[chunkId] + ".chunk.js";
};